export default __webpack_public_path__ + "static/media/15.8594f502.jpg";